<div class="cluster-amenities -eva-3-mb-sm" [ngClass]="isMobile ? '-eva-3-mt-lg' : '-eva-3-mt-xlg'">
    <div *ngIf="baggageDetails.suitcaseRestriction?.maximumAllowed" class="item">
        <span class="amenity-icon" [ngClass]="[isMobile ? '-eva-3-icon-sm' : '-eva-3-icon-md', 'eva-3-icon-suitcase-filled']"></span>
        <div class="amenity-text eva-3-p -eva-3-mt-xsm">
            <span>{{baggageDetails.suitcaseRestriction.text}}</span>
        </div>
    </div>
    <div *ngIf="baggageDetails.carryOnRestriction?.maximumAllowed" class="item">
        <span class="amenity-icon" [ngClass]="[isMobile ? '-eva-3-icon-sm' : '-eva-3-icon-md', 'eva-3-icon-handbag-filled']"></span>
        <div class="amenity-text eva-3-p -eva-3-mt-xsm">
            <span>{{baggageDetails.carryOnRestriction.text}}</span>
        </div>
    </div>
    <div *ngIf="baggageDetails.handbagRestriction?.maximumAllowed" class="item">
        <span class="amenity-icon" [ngClass]="[isMobile ? '-eva-3-icon-sm' : '-eva-3-icon-md', 'eva-3-icon-backpack-filled']"></span>
        <div class="amenity-text eva-3-p -eva-3-mt-xsm">
            <span>{{baggageDetails.handbagRestriction.text}}</span>
        </div>
    </div>
</div>
